import { render, staticRenderFns } from "./ReturnRefundPolicy.vue?vue&type=template&id=c22a69ac&scoped=true&"
var script = {}
import style0 from "./ReturnRefundPolicy.vue?vue&type=style&index=0&id=c22a69ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c22a69ac",
  null
  
)

export default component.exports